import React from 'react';
import { STUDENT_MENU } from '../../utils/const';
import MenuLink from './MenuLink';

// Состав меню — в utils/const (STUDENT_MENU), один источник с поиском по меню.
const StudentMenu = () => (
  STUDENT_MENU.map(({ name, to }) => (
    <MenuLink name={name} to={to} key={to} />
  ))
);

export default StudentMenu;
